import React, { useCallback } from 'react';
import { LocationSelector } from '../LocationSelector';
import '../layout/HeroSlideshow.css';
import { HERO_HEADLINE, HERO_SUBHEADLINE, HERO_TRUST_LINE } from './homePageConstants';
import './HomePage.css';

interface HomeHeroProps {
  onLocationSelect: (location: string) => void;
  citiesCount: number;
  countiesCount: number;
  communitiesCount: number;
  showDevHint?: boolean;
}

const HERO_IMAGE = '/images/slideshow/los-angeles.jpg';

export const HomeHero: React.FC<HomeHeroProps> = ({
  onLocationSelect,
  citiesCount,
  countiesCount,
  communitiesCount,
  showDevHint,
}) => {
  const focusSearch = useCallback(() => {
    document.getElementById('home-location-search')?.focus();
  }, []);

  const scrollToMembership = useCallback(() => {
    document.getElementById('public-vs-membership')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return (
    <div className="hero-slideshow home-hero">
      <div className="slideshow-container">
        <div
          className="slide active"
          style={{ backgroundImage: `url(${HERO_IMAGE})`, transform: 'translateX(0)' }}
        >
          <div className="slide-overlay" />
          <div className="slide-content home-hero__content">
            <div className="slide-text">
              <h1 className="slide-title">{HERO_HEADLINE}</h1>
              <p className="slide-subtitle">{HERO_SUBHEADLINE}</p>
            </div>

            <div className="slide-actions slide-actions--location home-hero__actions">
              <div className="home-hero__cta-row">
                <button
                  type="button"
                  className="home-hero__cta home-hero__cta--primary"
                  onClick={focusSearch}
                >
                  Explore Your Community
                </button>
                <button
                  type="button"
                  className="home-hero__cta home-hero__cta--secondary"
                  onClick={scrollToMembership}
                >
                  Learn About Membership
                </button>
              </div>

              <h2 className="slide-location-label">Find your city or county</h2>
              <LocationSelector
                onLocationSelect={onLocationSelect}
                placeholder="Search for any California city or county"
                className="hero-location-selector"
                inputId="home-location-search"
              />

              {showDevHint && (
                <p className="home-hero__dev-hint">
                  Database not loaded. Check browser console (F12) for errors.
                </p>
              )}

              <dl className="home-hero__stats" aria-label="Platform coverage">
                <div>
                  <dt>{citiesCount || '459'}</dt>
                  <dd>Cities</dd>
                </div>
                <div>
                  <dt>{countiesCount || '58'}</dt>
                  <dd>Counties</dd>
                </div>
                <div>
                  <dt>{communitiesCount || '518'}</dt>
                  <dd>Communities</dd>
                </div>
                <div>
                  <dt>100+</dt>
                  <dd>Indicators</dd>
                </div>
              </dl>
              <p className="home-hero__trust-line">{HERO_TRUST_LINE}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
